// extracted by mini-css-extract-plugin
export default {"loginForm":"styles_loginForm__iqQg0","innerForm":"styles_innerForm__a9Ozg","logo":"styles_logo__H5Nqm"};